import ResourceImages from './ResourceImages';

export default ResourceImages;
